import React, { useEffect, useState, useRef } from 'react';
import { FaUserCircle, FaSignOutAlt, FaKey } from 'react-icons/fa';
import { useAuth } from './hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const TopBar = () => {
  const [avatarUrl, setAvatarUrl] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { logoutUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
      const avatar = pbAuth?.record?.Avatar;
      const avatarFullUrl = `${process.env.REACT_APP_PB_URL || ''}/api/files/contacts/${pbAuth.record.id}/${avatar}`;
      console.log("avatarFullUrl", avatarFullUrl);
      setAvatarUrl(avatarFullUrl);
    } catch (e) {
      setAvatarUrl('');
    }
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      const refCurrent = dropdownRef.current;
      if (refCurrent && refCurrent.contains && !refCurrent.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleLogout = () => {
    setDropdownOpen(false);
    logoutUser();
    navigate('/login');
  };

  return (
    <header className="w-full h-16 bg-[#101828] flex items-center justify-end px-4 md:px-8 shadow-md">
      <div className="flex items-center space-x-4 relative" ref={dropdownRef}>
        {/* Avatar Button */}
        <button
          className="relative focus:outline-none cursor-pointer"
          onClick={() => setDropdownOpen((open) => !open)}
        >
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="User Avatar"
              className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-[#101828] object-cover"
            />
          ) : (
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-400 flex items-center justify-center text-white font-bold">
              ?
            </div>
          )}
          {/* Green status indicator */}
          {/* <span className="absolute bottom-0 right-0 w-3 h-3 bg-[#7ed957] border-2 border-[#101828] rounded-full"></span> */}
        </button>
        {/* Dropdown */}
        {dropdownOpen && (
          <div className="absolute top-full mt-2 right-0 w-48 bg-white rounded-lg shadow-lg py-2 z-50 border border-gray-100">
            <button
              className="w-full flex items-center gap-3 text-left px-4 py-2 hover:bg-[#232d47] hover:text-white text-[#101828] transition-colors duration-150"
              onClick={() => { setDropdownOpen(false); navigate('/profile'); }}
            >
              <FaUserCircle className="text-lg" />
              <span>Profile</span>
            </button>
            <button
              className="w-full flex items-center gap-3 text-left px-4 py-2 hover:bg-[#232d47] hover:text-white text-[#101828] transition-colors duration-150"
              onClick={() => { setDropdownOpen(false); navigate('/change-password'); }}
            >
              <FaKey className="text-lg" />
              <span>Change password</span>
            </button>
            <button
              className="w-full flex items-center gap-3 text-left px-4 py-2 hover:bg-[#232d47] hover:text-white text-[#101828] transition-colors duration-150"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="text-lg" />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default TopBar; 